import { HttpClient } from '@angular/common/http';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { SocketIoConfig } from 'ngx-socket-io';
import htmlbars from 'highlight.js/lib/languages/htmlbars';
import xml from 'highlight.js/lib/languages/xml';
import { environment } from '../environments/environment';
import { MatSnackBarModule } from '@angular/material';
export function hljsLanguages() {
    return [
        { name: 'htmlbars', func: htmlbars },
        { name: 'xml', func: xml }
    ];
}
export function createHttpLoader(http) {
    return new TranslateHttpLoader(http);
}
var DEFAULT_PERFECT_SCROLLBAR_CONFIG = {
    suppressScrollX: true,
    wheelSpeed: 2,
    wheelPropagation: true
};
var material = [
    MatSnackBarModule,
];
/**
 * WEBSOCKET REFERENCE
 *
 */
var wssconfig = {
    url: environment.socketsURL,
    options: {
        transports: ["websocket"],
        reconnection: true,
        autoConnect: true
    }
};
var ɵ0 = DEFAULT_PERFECT_SCROLLBAR_CONFIG, ɵ1 = {}, ɵ2 = {};
var AppModule = /** @class */ (function () {
    function AppModule() {
    }
    return AppModule;
}());
export { AppModule };
export { ɵ0, ɵ1, ɵ2 };
